<ng-container *ngIf="{
  request: requestData$ | async,
  status : requestIsPending$ | async,
  hideBlock: hideBlock$ | async,
  data: energyDataOverview$ | async,
} as resolver">
  <ng-container *ngIf="resolver.data as graphOpts; else noDataSkeleton">
    <lib-block-title
      id="block-title"
      [title]="labels.title">
    </lib-block-title>
    <app-button-toggle-select
      *ngIf="selectedMode$ | async as mode"
      id="button-toggle"
      class="fx-row fx-center"
      [ngClass]="{ 'visibility: hidden' : todayMode }"
      [value]="mode"
      [options]="[{
        value: 'day',
        label: labels.day,
      }, {
        value: 'month',
        label: labels.month,
      },
      {
        value: 'year',
        label: labels.year,
      }]"
      (valueChange)="changeSelectMode($event)">
    </app-button-toggle-select>
    <calendar-picker
      *ngIf="selectedMode$ | async as mode"
      id="calendar-picker"
      class="w-full"
      [ngClass]="{ 'visibility: hidden' : todayMode }"
      [startView]="mode === 'day' ? 'month' : mode === 'month' ? 'year' : 'multi-year'"
      [disabled]="resolver.status || false"
      [mode]="mode"
      (dateSelected)="dateSelection$.next($event)">
    </calendar-picker>
    <div
      *ngIf="graphOpts.hasValues && graphOpts.selfConsumeChartOptions; else noDataConsume"
      id="self-consume"
      class="w-full block-bg-contrast fx-row fx-center"
      echarts
      [options]="graphOpts.selfConsumeChartOptions"
      (chartInit)="onChartInit($event)">
    </div>
    <div
      *ngIf="graphOpts.hasValues && graphOpts.selfProduceChartOptions; else noDataProduction"
      id="self-production"
      class="w-full block-bg-contrast fx-row fx-center"
      echarts
      [options]="graphOpts.selfProduceChartOptions"
      (chartInit)="onChartInit($event)">
    </div>

    <ng-template #noDataConsume>
      <div
        id="self-consume"
        class="w-full block-bg-contrast fx-col fx-center fx-gap-3">
        <mat-icon
          class="s-20"
          svgIcon="no_data">
        </mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
        </span>
      </div>
    </ng-template>

    <ng-template #noDataProduction>
      <div
        id="self-production"
        class="w-full block-bg-contrast fx-col fx-center fx-gap-3">
        <mat-icon
          class="s-20"
          svgIcon="no_data">
        </mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
        </span>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
<ng-template #noDataSkeleton>
  <ion-skeleton-text
    id="title"
    class="w-35 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="button-toggle"
    class="w-44 h-8"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="self-consume"
    class="w-full h-50"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="self-production"
    class="w-full h-50"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>
